import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";

export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

const openedMixin = (theme) => ({
  width: drawerWidth,
  borderRight: "none",
  zIndex: 1099,
  background: theme.palette.background.default,
  overflowX: "hidden",
  boxShadow: "none",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen + 200,
  }),
});

const closedMixin = (theme) => ({
  borderRight: "none",
  zIndex: 1099,
  background: theme.palette.background.default,
  overflowX: "visible",
  overflowY: "visible",
  width: 72,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen + 200,
  }),
});

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  borderRight: "0px",
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default MiniDrawerStyled;
